import { globalApiParams } from './globals';
import { get, getSingleFile } from '../../helpers/axiosWrapper';

export const getSpecificDocumentRepository = async (
  url: string | undefined,
  context: any,
  page: number,
  userType: 'Customer' | 'TPIUser',
  customerAccountReferences: string[]
): Promise<Common.IResult<Api.IDocumentRepository>> => {
  const documentScope = 'Specific';

  let refQuery = '';
  customerAccountReferences.forEach((customerReference: string) => {
    refQuery += `&customeraccountreferences=${customerReference}`;
  });

  return await get(
    `${url}/documentmanagement/getdocumentdetails?page=${page}&pageSize=${globalApiParams.pageSize}&usertype=${userType}&scope=${documentScope}${refQuery}`,
    {},
    context
  );
};

export const getGenericDocumentRepository = async (
  url: string | undefined,
  context: any,
  page: number,
  userType: 'Customer' | 'TPIUser'
): Promise<Common.IResult<Api.IDocumentRepository>> => {
  const documentScope = 'Generic';

  return await get(
    `${url}/documentmanagement/getdocumentdetails?page=${page}&pageSize=${globalApiParams.pageSize}&usertype=${userType}&scope=${documentScope}`,
    {},
    context
  );
};

export const downloadGenericDocument = async (url: string | undefined, context: any, id: number): Promise<any> => {
  return await getSingleFile(`${url}/documentmanagement/getdocument/${id}`, {}, context);
};

export const downloadSpecificDocument = async (url: string | undefined, context: any, id: number): Promise<any> => {
  return await getSingleFile(`${url}/documentmanagement/getdocument/${id}`, {}, context);
};
